import React, { useEffect, useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Binocular from "./Binocular";
import RoadmapCard from "../components/smsc/RoadmapCard";

import Snowboard from "../assets/roadmap/smsc_snow_board.png";
import Explorer from "../assets/roadmap/smsc_explorer.png";
import Cat from "../assets/roadmap/smsc_cat.png";
import BucketOne from "../assets/roadmap/smsc_bucket_hat_1.png";
import BucketTwo from "../assets/roadmap/smsc_bucket_hat_2.png";

const RoadmapItems = [
  {
    title: "The journey begins",
    copy: "From 3 different continents, the SMSC team is established. Talented artists, designers and blockchain developers join the NFT community, delivering quality only seen in blockbuster movies and best selling games.<br/><br/> The mission: create 6,000 uniquely styled sloths and help endangered animals.",
    image: Snowboard,
  },
  {
    title: "Art front and center",
    copy: "The first of the sloths make their appearance, and the flood gates are opened. Discord and the website are launched as we build our community and make new friends.",
    image: Explorer,
  },
  {
    title: "Sloth adoption program",
    copy: "Whitelist slots are open, and everyone has an equal chance to become one of the 1,000 early adopters. Don’t sloth on this one.",
    image: Cat,
  },
  {
    title: "Sales go live",
    copy: "Whitelist: March 18th @ 6pm EST<br/> Public: March 20th @ 2pm EST",
    image: BucketOne,
  },
  {
    title: "The Grand reveal",
    copy: "6,000 unique sloths are revealed. 10% of our profits are donated to selected charities working together to save endangered animals.<br/> Phase two of the roadmap is made public.",
    image: BucketTwo,
  },
];

function Grass(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-2 10 1444 489"
      {...props}
    >
      <g>
        <path
          d="M1442 95.135c-2.26 4.483-4.53 8.959-6.85 13.386-5.72 10.945-17.95 32.057-16.62 44.819a104.586 104.586 0 018.26-53.106c-14.09 11.807-36.26 34.223-34.68 54.452a124.865 124.865 0 0110.58-60.614 208.562 208.562 0 00-38.14 64.819 180.183 180.183 0 019.03-73.656 173.262 173.262 0 00-34.42 76.61 286.733 286.733 0 01-8.17-77.537c-15.39 23.474-20.54 53.25-13.9 80.409l-30.9-74.854c2.04 23.75 5.9 47.307 11.55 70.46-8.27-30.637-26.32-58.633-50.95-79.014a595.222 595.222 0 0122.48 87.489c-10.69-31.673-28.4-60.493-51.82-84.277a449.754 449.754 0 0119.45 91.436 240.022 240.022 0 00-39.51-87.058 756.8 756.8 0 0116.3 81.294 471.575 471.575 0 00-38.25-79.764 181.448 181.448 0 015.96 80.043 165.705 165.705 0 01-10.09-34.424 84.688 84.688 0 01-13.08 31.507v-24.344a106.467 106.467 0 00-14.66 28.615l6.85-34.559a137.589 137.589 0 00-25.69 35.97 105.992 105.992 0 0111.67-37.332 70.816 70.816 0 00-29.2 32.996c5.24-13.401 10.48-26.814 15.73-40.237a86.168 86.168 0 00-31.03 37.603 217.505 217.505 0 0125.16-50.526 116.186 116.186 0 00-37.62 42.998 118.206 118.206 0 0117.81-51.281c-19.17 10.06-34.51 27.077-42.41 47.023a137.692 137.692 0 0117.31-48.77c-18.5 11.187-32.93 28.762-40.19 48.93a261.848 261.848 0 0111.11-49c-15.71 12.48-26.5 30.85-29.66 50.505a152.236 152.236 0 015.79-47.56c-18.45 11.869-29.144 34.523-26.476 56.094a391.38 391.38 0 01-10.905-57.546 131.633 131.633 0 00-2.333 54.822l-35.113-70.017a484.648 484.648 0 0115.383 72.663 213.651 213.651 0 00-41.965-72.348 167.532 167.532 0 0118.095 81.738 447.851 447.851 0 00-35.713-83.021 359.436 359.436 0 014.085 80.757 1047.977 1047.977 0 01-16.343-78.604l.687 81.492-18.092-83.145a1231.614 1231.614 0 01-6.382 83.28 172.556 172.556 0 00-8.143-52.79 213.92 213.92 0 01-5.626 49.812 100.305 100.305 0 00-6.97-40.032 210.088 210.088 0 01-5.945 35.794l-7.702-30.428c-7.922 11.421-17.275 21.169-24.315 33.062a63.61 63.61 0 018.765-38.416 471.685 471.685 0 00-31.87 35.741 148.586 148.586 0 0118.86-39.917 263.692 263.692 0 00-42.725 36.647 284.607 284.607 0 0130.934-45.303 185.365 185.365 0 00-51.13 42.829c4.662-23.384 18.509-44.827 37.998-58.882a170.605 170.605 0 00-60.8 50.682 115.618 115.618 0 0138.463-55.515 143.253 143.253 0 00-53.25 43.507 273.78 273.78 0 0134.921-55.675 350.066 350.066 0 00-53.523 51.576 198.578 198.578 0 0138.488-65.065 200.776 200.776 0 00-51.657 56.873 101.736 101.736 0 0122.472-55.425c-19.309 12.85-33.638 32.82-39.514 55.043a286.418 286.418 0 019.328-48.947 114.988 114.988 0 00-20.907 57.583c-.931-18.65-1.864-37.298-2.798-55.946a124.942 124.942 0 00-4.433 50.05 289.08 289.08 0 01-22.391-57.024 191.265 191.265 0 0013.132 58.731 356.824 356.824 0 01-53.491-63.219 413.006 413.006 0 0127.959 74.378 329.928 329.928 0 01-42.553-64.261l19.746 72.433-41.634-63.642a245.71 245.71 0 0116.776 69.615c-10.8-22.107-21.597-44.213-32.392-66.32a189.203 189.203 0 0114.795 70.816l-37.487-76.835a198.018 198.018 0 0110.088 92.019l-27.293-94.886a274.724 274.724 0 01-.638 93.987l-16.179-92.937a365.321 365.321 0 01-9.929 94.705 1174.43 1174.43 0 01-2.978-83.16 412.182 412.182 0 01-22.533 79.874 643.127 643.127 0 014.972-83.973 480.831 480.831 0 01-39.424 59.703 353.728 353.728 0 0114.897-54.046l-40.224 51.486a104.083 104.083 0 0126.357-55.043 199.685 199.685 0 00-50.831 54.6c5.156-16.935 10.315-33.867 15.477-50.797a225.765 225.765 0 01-46.28 54.075 107.336 107.336 0 0116.789-37.103 111.86 111.86 0 00-39.677 35.282c7.472-22.088 22.243-41.714 41.515-55.162-23.726 7.577-44.584 28.171-58.476 48.097a180.275 180.275 0 0142.084-59.847c-26.762 9.346-49.969 28.262-64.318 52.43 6.643-23.893 21.409-45.513 41.368-60.557-27.93 11.335-50.811 34.149-62.022 61.788a143.048 143.048 0 0138.672-71.92c-26.656 14.542-46.169 41.258-51.669 70.812-1.389-30.912 8.172-62.194 26.644-87.198-25.361 23.355-41.451 56.265-44.188 90.385a281.793 281.793 0 0113.646-110.18c-19.509 34.593-28.069 75.1-24.196 114.5a834.039 834.039 0 01-17.568-118.88c.868 39.615-.037 79.219-2.718 118.811a746.33 746.33 0 00-23.35-125.905 375.61 375.61 0 01.507 119.694l-16.425-102.59c.474 33.913-.116 67.827-1.769 101.74a583.409 583.409 0 01-15.444-84.576 289.142 289.142 0 01-8.621 80.228c-1.455-25.767-2.908-51.535-4.36-77.307a303.78 303.78 0 01-14.325 85.577 630.691 630.691 0 01-1.45-105.63 525.742 525.742 0 00-13.369 101.815A1588.437 1588.437 0 0153.431 10a300.025 300.025 0 01-22.124 121.249 1005.14 1005.14 0 012.811-96.774 246.484 246.484 0 00-21.05 80.04 235.93 235.93 0 0114.3-103.059C20.273 27.788 6.819 42.545-2 57.978V499h1444V95.135z"
          fill="url(#paint0_linear_1074_8441)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_1074_8441"
          x={-12}
          y={0}
          width={1464}
          height={509}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            stdDeviation={5}
            result="effect1_foregroundBlur_1074_8441"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1074_8441"
          x1={720}
          y1={-45.602}
          x2={720}
          y2={536.73}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0C3F2B" />
          <stop offset={1} stopColor="#0C3F2B" stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  );
}

function BottomRightLeaf(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="96.21 78.25 838.58 521.73"
      {...props}
    >
      <g filter="url(#filter0_f_1074_8372)">
        <path
          d="M763.345 293.657l5.382 59.775c-75.45 77.553-155.685 131.327-233.51 168.307l-5.143-104.987-25.211 118.641c-217.859 92.425-408.656 58.503-408.656 58.503 33.626-89.036 71.565-163.291 112.248-225.163l51.474 34.623-37.261-55.506C364.771 144.656 537.245 85.767 676.912 78.995l41.715 54.25-23.319-54.905c137.919-2.426 239.477 43.887 239.477 43.887-44.196 83.28-95.561 156.349-153.24 217.992l-18.2-46.562z"
          fill="#0C3F2B"
        />
        <path
          d="M912.595 127.498S367.723 255.272 112.423 580.649c0 0 202.523-258.582 800.172-453.151z"
          fill="#B9FFD9"
        />
        <path
          d="M736.3 190.903l-81.273-85.192 72.342 83.129 8.931 2.063zM636.777 232.604l-67.993 175.312 57.488-175.909 10.505.597zM552.953 265.656l-109.351-80.13 98.859 81.437 10.492-1.307zM414.306 340.374l-66.122 149.744 76.411-157.012-10.289 7.268zM316.94 391.85l-62.274-39.093 60.231 46.775 2.043-7.682zM246.307 458.067l-19.211 60.965 12.079-67.654 7.132 6.689z"
          fill="#B9FFD9"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_1074_8372"
          x={89.207}
          y={71.248}
          width={852.578}
          height={535.727}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            stdDeviation={3.5}
            result="effect1_foregroundBlur_1074_8372"
          />
        </filter>
      </defs>
    </svg>
  );
}

function TopRightLeaf(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="49.55 40.3 431.9 268.71"
      {...props}
    >
      <g filter="url(#filter0_f_1074_8361)">
        <path
          d="M393.152 151.244l2.771 30.787c-38.859 39.942-80.183 67.638-120.266 86.684l-2.649-54.072-12.984 61.105C147.818 323.35 49.55 305.879 49.55 305.879c17.319-45.857 36.859-84.101 57.812-115.968l26.511 17.833-19.19-28.588C187.871 74.503 276.702 44.173 348.635 40.686l21.485 27.94-12.01-28.278c71.034-1.25 123.34 22.603 123.34 22.603-22.763 42.892-49.218 80.526-78.925 112.274l-9.373-23.981z"
          fill="#0C3F2B"
        />
        <path
          d="M470.021 65.666s-280.63 65.809-412.119 233.39c0 0 104.307-133.179 412.119-233.39z"
          fill="#B9FFD9"
        />
        <path
          d="M379.222 98.323l-41.859-43.877 37.259 42.814 4.6 1.063zM414.219 84.957l-13.791 28.533 18.114-30.105-4.323 1.572zM327.964 119.8l-35.019 90.293 29.609-90.6 5.41.307zM284.791 136.823l-56.32-41.27 50.916 41.943 5.404-.673zM213.382 175.305l-34.055 77.124 39.355-80.867-5.3 3.743zM163.236 201.817l-32.074-20.134 31.022 24.091 1.052-3.957zM126.857 235.922l-9.895 31.399 6.221-34.844 3.674 3.445z"
          fill="#B9FFD9"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_1074_8361"
          x={42.5508}
          y={33.3005}
          width={445.898}
          height={282.709}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            stdDeviation={3.5}
            result="effect1_foregroundBlur_1074_8361"
          />
        </filter>
      </defs>
    </svg>
  );
}

function BottomLeftLeaf(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-19.66 40.3 431.9 268.71"
      {...props}
    >
      <g filter="url(#filter0_f_1074_8350)">
        <path
          d="M68.641 151.244l-2.771 30.787c38.859 39.942 80.183 67.638 120.266 86.684l2.649-54.072 12.984 61.105c112.206 47.602 210.474 30.131 210.474 30.131-17.319-45.857-36.859-84.101-57.812-115.968l-26.511 17.833 19.19-28.588C273.922 74.503 185.091 44.173 113.158 40.686l-21.486 27.94 12.011-28.278C32.649 39.098-19.657 62.95-19.657 62.95c22.763 42.892 49.218 80.526 78.925 112.274l9.373-23.981z"
          fill="#0C3F2B"
        />
        <path
          d="M-8.228 65.666s280.63 65.809 412.119 233.39c0 0-104.307-133.179-412.12-233.39z"
          fill="#B9FFD9"
        />
        <path
          d="M82.571 98.322l41.859-43.877L87.17 97.26l-4.599 1.062zM47.574 84.957l13.791 28.533-18.114-30.105 4.323 1.572zM133.829 119.8l35.019 90.292-29.609-90.6-5.41.308zM177.002 136.823l56.32-41.27-50.916 41.943-5.404-.673zM248.411 175.305l34.055 77.124-39.355-80.867 5.3 3.743zM298.557 201.817l32.074-20.134-31.022 24.091-1.052-3.957zM334.936 235.922l9.895 31.399-6.221-34.844-3.674 3.445z"
          fill="#B9FFD9"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_1074_8350"
          x={-26.6562}
          y={33.3003}
          width={445.898}
          height={282.709}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            stdDeviation={3.5}
            result="effect1_foregroundBlur_1074_8350"
          />
        </filter>
      </defs>
    </svg>
  );
}

function TopLeftLeaf(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="15.23 71.68 306.77 135.14"
      {...props}
    >
      <g filter="url(#filter0_f_1074_8304)">
        <path
          d="M95.87 191.691l13.044 15.116c35.995-.092 67.413-6.829 94.259-16.876l-23.906-25.521 34.193 21.424c72.498-30.692 108.534-84.149 108.534-84.149-29.063-12.562-55.59-20.673-79.793-25.264l-3.633 20.315-4.647-21.749c-81.45-13.045-135.432 14.558-169.365 46.377l3.316 22.523-7.729-18.277c-32.49 32.406-44.917 67.398-44.917 67.398 30.133 8.704 59.484 13.332 87.564 13.806l-6.92-15.123z"
          fill="#0C3F2B"
        />
        <path
          d="M21.62 188.924s156.609-100.682 293.455-86.426c0 0-108.668-11.418-293.455 86.426z"
          fill="#B9FFD9"
        />
        <path
          d="M77.566 161.452l-1.56-39.138 3.133 36.526-1.573 2.612zM55.64 171.69l19.44 6.417-22.11-5.117 2.67-1.3zM110.56 147.312l57.638 24.308-55.35-26.958-2.288 2.65zM137.856 134.92l6.146-44.678-3.406 42.473-2.74 2.205zM187.795 119.066l51.093 18.841-55.211-18.063 4.118-.778zM222.628 107.701l5.063-23.93-2.754 25.219-2.309-1.289zM254.798 106.138l19.018 9.513-18.966-12.765-.052 3.252z"
          fill="#B9FFD9"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_1074_8304"
          x={4.22656}
          y={60.6777}
          width={328.768}
          height={157.137}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            stdDeviation={5.5}
            result="effect1_foregroundBlur_1074_8304"
          />
        </filter>
      </defs>
    </svg>
  );
}

function TopVine(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-48 0 1573.09 303"
      {...props}
    >
      <path
        d="M989.512 303c-22.677 0-45.396-.427-68.159-1.282-165.641-6.239-334.164-35.096-500.893-85.759C136.576 129.687-46.205 8.319-48 7.102L-43.258 0c1.804 1.21 183.724 121.983 466.473 207.861 260.808 79.213 663.235 144.089 1099.265 3.321l2.61 8.119C1352.86 274.925 1172.99 303 989.512 303z"
        fill="#0C3F2B"
      />
    </svg>
  );
}

function BottomVine(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-102.96 9.05 1567.81 320.88"
      {...props}
    >
      <g filter="url(#filter0_f_1074_8349)">
        <path
          d="M975.825 249.969a1816.855 1816.855 0 01-65.659 18.334c-160.462 41.564-330.178 62.289-504.433 61.61-296.701-1.165-506.625-64.967-508.695-65.619l2.505-8.164c2.075.641 211.004 64.121 506.505 65.235 272.57 1.026 676.682-52.328 1053.972-312.318l4.83 7.027C1315.82 118.793 1151.58 197.31 975.825 249.97z"
          fill="#0C3F2B"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_1074_8349"
          x={-111.961}
          y={0.0473633}
          width={1585.81}
          height={338.881}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            stdDeviation={4.5}
            result="effect1_foregroundBlur_1074_8349"
          />
        </filter>
      </defs>
    </svg>
  );
}

function BinocularMobile(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320 410"
      {...props}
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M320 0H0v410h320V0zM160 357c83.947 0 152-68.053 152-152S243.947 53 160 53 8 121.053 8 205s68.053 152 152 152z"
          fill="#0D3727"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_1076_7093"
          x={-5}
          y={-5}
          width={330}
          height={420}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            stdDeviation={2.5}
            result="effect1_foregroundBlur_1076_7093"
          />
        </filter>
      </defs>
    </svg>
  );
}

const Roadmap = (props) => {
  gsap.registerPlugin(ScrollTrigger);

  const ref = useRef(null);

  useLayoutEffect(() => {
    // Create gsap timeline with a scroll trigger

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: ref.current,
        start: `center center`,
        scrub: true,
        end: "+=" + window.innerHeight * 5,

        pin: true,
      },
    });

    ScrollTrigger.matchMedia({
      "(min-width:1025px)": function () {
        tl.fromTo(
          ".binocular",
          {
            scale: 1,
          },
          {
            scale: 1.5,
            duration: 2.5,
          },
          "0"
        );

        tl.fromTo(
          ".roadmap-title",
          {
            scale: 1,
            opacity: 1,
            y: 0,
          },
          {
            scale: 0.5,
            opacity: 0,
            y: `-24vh`,
            duration: 2.5,
          },
          "0"
        );

        tl.fromTo(
          ".box-items",
          {
            x: "100%",
          },
          {
            x: `-40.7518%`,
            duration: 7.5,
          },
          "0"
        );

        tl.fromTo(
          ".binocular-grass",
          {
            y: `25%`,
          },
          {
            y: 0,
            duration: 2.5,
          },
          "0"
        );
      },
      "(max-width:1025px)": function () {
        tl.fromTo(
          ".binocular",
          {
            scale: 1,
          },
          {
            scale: 2,
            duration: 2.5,
          },
          "0"
        );

        tl.fromTo(
          ".roadmap-title",
          {
            scale: 1,
            y: 0,
            opacity: 1,
          },
          {
            opacity: 0,
            scale: 0.5,
            y: `-35vh`,
            duration: 2.5,
          },
          "0"
        );

        tl.fromTo(
          ".box-items",
          {
            y: "100%",
          },
          {
            y: `-45%`,
            duration: 7.5,
          },
          "0"
        );

        tl.fromTo(
          ".binocular-grass",
          {
            y: `25%`,
            opacity: 1,
          },
          {
            y: 0,
            opacity: 0,
            duration: 2.5,
          },
          "0"
        );
      },
    });

    tl.fromTo(
      ".b-top-vine",
      {
        scale: 1,
        opacity: 1,
        y: 0,
      },
      {
        scale: 1.2,
        opacity: 0.5,
        y: `-50vh`,
        duration: 0.5,
      },
      "0"
    );

    tl.fromTo(
      ".b-bottom-r-leaf",
      {
        scale: 1,
        x: 0,
        rotate: 0,
      },
      {
        scale: 1.7,
        rotate: -25,
        x: `50vw`,
        duration: 0.5,
      },
      "0"
    );
    tl.fromTo(
      ".b-bottom-l-leaf",
      {
        scale: 1,
        x: 0,
        rotate: 0,
      },
      {
        scale: 1.7,
        rotate: -25,
        x: `-50vw`,
        duration: 1,
      },
      "0"
    );

    tl.fromTo(
      ".b-bottom-vine",
      {
        scale: 1,
        opacity: 1,
        y: 0,
      },
      {
        scale: 1.2,
        opacity: 0.5,
        y: `-50vh`,
        duration: 1.5,
      },
      "0"
    );

    tl.fromTo(
      ".b-top-r-leaf",
      {
        scale: 1,
        opacity: 1,
        x: 0,
      },
      {
        scale: 1.2,
        opacity: 0.5,
        rotate: -25,
        x: `40vw`,
        duration: 1.5,
      },
      "0"
    );

    tl.fromTo(
      ".b-top-l-leaf",
      {
        scale: 1,
        opacity: 1,
        x: 0,
      },
      {
        scale: 1.2,
        rotate: -25,
        opacity: 0.5,
        x: `-40vw`,
        duration: 1.5,
      },
      "0"
    );
  }, []);

  return (
    <section className="bg-[#0D3727] relative overflow-hidden" id="roadmap">
      <div
        ref={ref}
        className="relative overflow-visible lg:overflow-hidden bg-[#E6FFF1]"
      >
        <div className="w-full h-screen lg:h-full flex flex-col lg:flex-row items-center justify-center binocular max-h-screen lg:max-h-max overflow-hidden">
          <div className="flex-grow bg-[#0D3727] w-screen lg:h-screen scale-y-105 translate-y-[-2px] lg:translate-x-[2px] lg:scale-x-110"></div>
          <div className="relative">
            <div className="b-bottom-r-leaf">
              <BottomRightLeaf />
            </div>

            <div className="b-top-r-leaf">
              <TopRightLeaf />
            </div>

            <div className="b-top-l-leaf">
              <TopLeftLeaf />
            </div>

            <div className="b-bottom-l-leaf">
              <BottomLeftLeaf />
            </div>

            <div className="absolute left-0 w-[100vw] top-[100px] b-bottom-vine z-[-10]">
              <BottomVine />
            </div>

            <div className="absolute left-0 w-[100vw] top-[50px] b-top-vine z-[-5]">
              <TopVine />
            </div>
            <div className="w-full absolute bottom-0 left-0 binocular-grass z-[-2]">
              <Grass />
            </div>

            <Binocular className="h-screen z-[999] translate-0 hidden lg:block" />
            <BinocularMobile className="w-screen z-[999] translate-0 lg:hidden" />
          </div>
          <div className="flex-grow bg-[#0D3727] w-screen lg:h-screen scale-y-105 translate-y-[2px] lg:translate-x-[-2px] lg:scale-x-110"></div>
        </div>
        <div className="absolute inset-0 w-full h-full flex items-center justify-center">
          <h2 className="uppercase text-[#0D3727] roadmap-title">Roadmap</h2>
        </div>

        <div className="absolute inset-0 w-full h-full flex items-center justify-center z-[-1]">
          <div className="flex flex-col lg:flex-nowrap lg:flex-row space-y-[35px] lg:space-y-0 lg:space-x-[50px] box-items">
            {RoadmapItems.map((item, index) => (
              <RoadmapCard key={index} {...item} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
